const DOMAIN = 'crunchyroll';

function initEvidon({ id }) {
  return new Promise((resolve) => {
    function append(scriptid, url, async, onLoad = () => {}) {
      const d = document;
      const sn = "script";

      let f = d.getElementsByTagName(sn)[0];

      if (!f) f = d.head;

      const s = d.createElement(sn);

      s.onload = onLoad;
      s.async = async;
      s.id = scriptid;
      s.src = url;
      s.charset = "utf-8";
      f.parentNode.insertBefore(s, f);
    }

    function is2parttld(value) {
      const tldindicators = [
        "co",
        "com",
        "info",
        "web",
        "info",
        "gov",
        "edu",
        "biz",
        "net",
        "org",
      ];
      const countryindicators = [
        "uk",
        "us",
        "fr",
        "es",
        "de",
        "at",
        "au",
        "ae",
        "be",
        "br",
        "ca",
        "ch",
        "cn",
        "co",
        "cz",
        "dk",
        "eg",
        "eu",
        "fi",
        "gb",
        "gr",
        "hk",
        "hr",
        "hu",
        "ie",
        "in",
        "jp",
        "mx",
        "nl",
        "no",
        "nz",
        "pl",
        "ro",
        "ru",
        "se",
      ];

      return (
        tldindicators.indexOf(value) !== -1 ||
        countryindicators.indexOf(value) !== -1
      );
    }
    let rootDomain;

    function getRootDomain() {
      const parts = window.location.hostname.split(".");

      if (parts.length === 2) [rootDomain] = parts;
      else if (parts.length > 2) {
        // see if the next to last value is a common tld
        const part = parts[parts.length - 2];

        if (is2parttld(part)) {
          rootDomain = parts[parts.length - 3]; // go back one more
        } else {
          rootDomain = part;
        }
      }

      return rootDomain;
    }

    window.evidon = {};
    window.evidon.id = id;
    window.evidon.test = false; // set to true for non-production testing.

    const cdn = "//c.evidon.com/";
    const noticecdn = `${cdn}sitenotice/`;

    rootDomain = getRootDomain() || DOMAIN;

    const noticeKey = "evidon-notice";
    const locationKey = "evidon-location";
    const settingsKey = "evidon-settings";

    const requiredToLoadSripts = {
      [noticeKey]: false,
      [locationKey]: false,
      [settingsKey]: false,
    };

    const shouldTriggerCallback = (scriptName) => () => {
      requiredToLoadSripts[scriptName] = true;

      if (Object.values(requiredToLoadSripts).every(Boolean)) {
        resolve();
      }
    };

    append(
      noticeKey,
      `${noticecdn}evidon-sitenotice-tag.js`,
      false,
      shouldTriggerCallback(noticeKey)
    );
    append(
      locationKey,
      `${cdn}geo/country.js`,
      true,
      shouldTriggerCallback(locationKey)
    );
    append("evidon-themes", `${noticecdn}${id}/snthemes.js`, true);
    if (rootDomain)
      append(
        settingsKey,
        `${noticecdn}${id}/${rootDomain}${
          window.evidon.test ? "/test" : ""
        }/settings.js`,
        true,
        shouldTriggerCallback(settingsKey)
      );

    window.evidon.priorConsentCallback = function priorConsentCallback(
      categories,
      vendors
    ) {
      // add the tags which need to wait for prior consent
      // here.  This should be all your advertising tags and
      // probably most of your social and tracking tags.
      const handlers = {
        categories: {},
        vendors: {
          addevent: "handleAddEvent",
          addthis: "handleAddThis",
          "addtoany-formerly-lockerz-share":
            "handleAddToAnyformerlyLockerzShare",
          addtocalendar: "handleAddToCalendar",
          adgear: "handleAdGear",
          adguardsoftwarelimited: "handleADGUARDSOFTWARELIMITED",
          adobe: "handleAdobe",
          "adobe-creative-cloud-typekit": "handleAdobeCreativeCloud",
          "adobe-marketing-cloud-analytics":
            "handleAdobeExperienceCloudAnalytics",
          "adobe-marketing-cloud-audience-manager":
            "handleAdobeExperienceCloudAudienceManager",
          "akamai-technologies": "handleAkamaiTechnologies",
          alexa: "handleAlexa",
          amazon: "handleAmazon",
          "amazon-associates": "handleAmazonAssociates",
          "amazon-cloudfront": "handleAmazonCloudFront",
          "amazon-web-services": "handleAmazonWebServices",
          amobee: "handleAmobee",
          "adconion-media-group": "handleAmobeeFormallyAdconionMediaGroup",
          "amp-project-accelerated-mobile-pages":
            "handleAMPProjectAcceleratedMobilePages",
          "aol-advertising": "handleAOLAdvertising",
          apple: "handleApple",
          appnexus: "handleAppNexus",
          atlas: "handleAtlas",
          bitmovin: "handleBitmovin",
          brightcove: "handleBrightcove",
          cdnjs: "handleCDNJS",
          clearplay: "handleClearplay",
          cloudflare: "handleCloudFlare",
          cogocast: "handleCogoCast",
          "crazy-egg": "handleCrazyEgg",
          datalogix: "handleDatalogix",
          demandware: "handleDemandware",
          "digital-point": "handleDigitalPoint",
          doubleclick: "handleDoubleClick",
          "doubleclick-bid-manager-formerly-invite-media":
            "handleDoubleClickBidManagerformerlyInviteMedia",
          evidon: "handleEvidon",
          facebook: "handleFacebook",
          "facebook-custom-audience":
            "handleFacebookBusinessformerlyFacebookCustomAudience",
          "facebook-connect":
            "handleFacebookforDevelopersformerlyFacebookConnect",
          "facebook-social-plugins": "handleFacebookSocialPlugins",
          firebase: "handleFirebase",
          "font-awesome": "handleFontAwesome",
          freshworks: "handleFreshworks",
          "full-circle-studies": "handleFullCircleStudies",
          sentry: "handleGetSentry",
          gigya: "handleGigya",
          "google-ad-services": "handleGoogleAdServices",
          "google-adsense": "handleGoogleAdSense",
          "google-adwords": "handleGoogleAdWords",
          "google-analytics": "handleGoogleAnalytics",
          googlefonts: "handleGoogleFonts",
          googleima: "handleGoogleIMA",
          google: "handleGoogleInc",
          "google-maps": "handleGoogleMaps",
          googlerecaptcha: "handleGooglereCAPTCHA",
          "google-tag-manager": "handleGoogleTagManager",
          "google-translate": "handleGoogleTranslate",
          hubspot: "handleHubSpot",
          "impact-radius": "handleImpactRadius",
          "casale-media": "handleIndexExchangeFormerlyCasaleMedia",
          instagram: "handleInstagram",
          iponweb: "handleIPONWEB",
          leadid: "handleJornayaformerlyLeadiD",
          jquery: "handlejQuery",
          jsDelivr: "handlejsDelivr",
          "jw-player": "handleJWPlayer",
          liveramp: "handleLiveRamp",
          loggly: "handleLoggly",
          loom: "handleLoom",
          "mailru-group": "handleMailRuGroup",
          maptiler: "handleMaptiler",
          microsoft: "handleMicrosoft",
          "microsoft-advertising": "handleMicrosoftAdvertising",
          "microsoft-bing-ads-formerly-microsoft-adcenter":
            "handleMicrosoftBingAdsformerlyMicrosoftadCenter",
          moat: "handleMoat",
          myfonts: "handleMyFonts",
          "aggregate-knowledge": "handleNeustarMarketingFormerlyPlatformOne",
          "new-relic": "handleNewRelic",
          nextroll: "handleNextRoll,Inc",
          openx: "handleOpenX",
          bluekai: "handleOracleDataCloud",
          outbrain: "handleOutbrain",
          pinterest: "handlePinterest",
          "polyfill-dot-io": "handlePolyfillio",
          powsterltd: "handlePOWSTERLTD",
          pubmatic: "handlePubMatic",
          quora: "handleQuora",
          rambler: "handleRambler",
          revjet: "handleRevJet",
          "rubicon-project": "handleRubiconProject",
          "krux-digital": "handleSalesforceDMPFormerlyKruxDigital",
          igodigital: "handleSalesforceMarketingCloudformerlyiGoDigital",
          semasio: "handleSemasio",
          simon: "handleSimon",
          sitescout: "handleSiteScout",
          "sizmek-formerly-mediamind": "handleSizmek",
          skimlinks: "handleSkimLinks",
          "snap-inc": "handleSnapInc",
          "sony-pictures-digital-productions":
            "handleSonyPicturesDigitalProductions",
          "sony-pictures": "handleSonyPicturesEntertainment",
          spotxchange: "handleSpotXchange",
          squarespace: "handleSquarespace",
          stackadapt: "handleStackAdapt",
          stackpath: "handleStackPath",
          stripe: "handleStripe",
          sycamoresoftwaresolutions: "handleSycamoreSoftwareSolutions",
          taboola: "handleTaboola",
          "tag-inspector": "handleTagInspector",
          tapad: "handleTapad",
          technorati: "handleTechnorati",
          "the-trade-desk": "handleTheTradeDesk",
          tiktok: "handleTikTok",
          "top-dot-mail": "handleTopMail",
          triplelift: "handleTripleLift",
          twitter: "handleTwitter",
          vimeo: "handleVimeo",
          "visual-website-optimiser-wingify":
            "handleVisualWebsiteOptimizerWingify",
          "vk-vkontakte": "handleVkVKontakte",
          yahoo: "handleYahoo",
          yandex: "handleYandex",
          youtube: "handleYouTube",
        },
      };

      const isFunction = (handler) => typeof handler === "function";
      const hasValue = ([, value]) => Boolean(value);

      Object.entries(categories)
        .filter(hasValue)
        .map(([category]) => window.evidon[handlers.categories[category]])
        .filter(isFunction)
        .forEach((handler) => handler());

      Object.entries(vendors)
        .filter(hasValue)
        .map(([vendor]) => window.evidon[handlers.vendors[vendor]])
        .filter(isFunction)
        .forEach((handler) => handler());
    };

    window.evidon.closeCallback = function closeCallback() {
      // this is executed if the user closed a UI element without either Accepting (providing consent)
      // or Declining (declining to provide consent).
    };

    window.evidon.consentWithdrawnCallback =
      function consentWithdrawnCallback() {
        // this is exeucted if the user withdraws consent and elects to
        // no longer allow technologies to run on the site.
      };

    window.evidon.consentDeclinedCallback = function consentDeclinedCallback() {
      // this is executed if the user explicitly declines giving consent by
      // using a Decline button
    };
  });
}

export default initEvidon;
